import React from 'react';
import { useAccountStatementInfo } from './AccountStatementInfo';
import { Account } from '../../../types/Account';

interface StatementCellProps {
  account: Account;
  field: 'lastBillAmount' | 'status' | 'dueDate';
}

const StatementCell: React.FC<StatementCellProps> = ({ account, field }) => {
  const statementInfo = useAccountStatementInfo(account);
  return <>{statementInfo[field]}</>;
};

export default StatementCell;
